<template>
  <div :class="$style.base" :style="style">
    <transition>
      <div v-show="isActive" :class="$style.icon">
        <IconCheck isSmall />
      </div>
    </transition>
  </div>
</template>

<script>
import IconCheck from '@/components/IconCheck.vue';
import widgetSettings from '@/widget-settings';

export default {
  components: {
    IconCheck
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    style() {
      return this.isActive
        ? {
            'background-color': widgetSettings.color,
            'border-color': widgetSettings.color
          }
        : {
            'border-color': widgetSettings.color
          };
    }
  }
};
</script>

<style lang="scss" module>
.base {
  min-width: 21px;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  border: 1px solid $color-font-dark;

  transition:
    background-color 0.05s $easing,
    border-color 0.05s $easing;
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 2px;

  &:global(.v-enter-active) {
    transition:
      opacity 0.05s $easing 0.1s,
      transform 0.3s $easeOutBack 0.05s;
  }

  &:global(.v-enter-from) {
    opacity: 0;
    transform: scale(0.1);
  }
}
</style>
